"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CordIamService = void 0;
const fetch_client_1 = require("./fetch-client");
class CordIamService extends fetch_client_1.FetchClient {
  constructor(baseUrl) {
    if (CordIamService.instance) {
      return CordIamService.instance;
    }
    super();
    if (baseUrl) {
      this.baseUrl = baseUrl;
    }
    CordIamService.instance = this;
  }
  appendConfirmEmailHeaderToken(token) {
    this.optionsWithEmailToken = Object.assign(Object.assign({}, this.options), {
      headers: Object.assign(Object.assign({}, this.options.headers), {
        EmailToken: token
      })
    });
  }
  ///// Modals to be added soon /////
  loginWithOAuthCode(provider, code, state = '') {
    return this.get(`oauth/login/${provider}?code=${code}&state=${state}`);
  }
  generateSSOLoginUrl(data) {
    return this.post('oauth/generateLoginUrl', data);
  }
  promoteTempUser(data) {
    return this.put('client/promoteTempUser', data);
  }
  updateOrganization(organization) {
    return this.put('organization', organization);
  }
  updateOrganizationStatus(organizationStatus) {
    return this.put('organization/status', organizationStatus);
  }
  getOrganization(organizationId) {
    return this.get('organization', organizationId);
  }
  getAllOrganizations() {
    return this.get('organization');
  }
  deleteOrganization(organizationId) {
    return this.delete(`organization/${organizationId}`);
  }
  getOrganizationContactInfo() {
    return this.get('user/organization');
  }
  createOrganization(data) {
    return this.post('organization', data);
  }
  getOrganizationByHDNSupplierId(HDNSupplierId) {
    return this.post('organization/search', HDNSupplierId);
  }
  createAgent(data) {
    return this.post('agent', data);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createSuperAgent(data) {
    return this.post('agent/createSuperagent', data);
  }
  getAgents(organizationId) {
    return this.get('agent', organizationId);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getSuperAgents(organizationId) {
    return this.get('agent/superagents', organizationId);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getUser(userId) {
    return this.get('user', userId);
  }
  deleteClient(data) {
    return this.post('client/delete', data);
  }
  deleteUser(data) {
    return this.post('user/delete', data);
  }
  changePassword(newPassword) {
    return this.put('password/changePassword', newPassword);
  }
  generateSecret(token) {
    return this.get(`twoFactorAuth/generateSecret${token ? '?emailToken=' + token : ''}`);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  verifySecret(totp) {
    return this.post('twoFactorAuth/verifySecret/' + totp, null);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  verifyCode(totp) {
    return this.post('twoFactorAuth/verifyCode/' + totp, null);
  }
  requestResetSecretCode() {
    return this.get('twoFactorAuth/requestNewSecret');
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateProfile(data) {
    return this.put('client/updateProfile', data);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  verifyEmail() {
    return this.get('client/verifyEmail');
  }
  searchOrganizations(queryObj) {
    return this.post('organization/graphQl', queryObj);
  }
  searchUsers(queryObj) {
    return this.post('GraphQl/search', queryObj);
  }
  getUserProfileImage() {
    return this.get('user/profile/image');
  }
  updateUserProfileImage(UpdateUserProfileImageRequest) {
    return this.put('user/profile/image', UpdateUserProfileImageRequest);
  }
  // USER PROFILE NOTIFICATION PREFERENCES
  getUserProfileNotificationPreferences(userId, source) {
    if (source) {
      return this.get(`notifications/${userId}?source=${source}`);
    }
    return this.get(`notifications/${userId}`);
  }
  updateUserProfileNotificationPreferences(userId, data) {
    return this.put(`notifications/${userId}`, data);
  }
  updateUserProfileNotificationPreferencesBySource(userId, data) {
    return this.patch(`notifications/${userId}`, data);
  }
  deleteUserProfileNotificationPreferences(userId, source) {
    if (source) {
      return this.delete(`notifications/${userId}?source=${source}`);
    }
    return this.delete(`notifications/${userId}`);
  }
  getClientListing(userTypes) {
    return this.post('user/ClientListing', userTypes);
  }
  verifyEmailToken(data) {
    return this.post('token', data);
  }
  saveUserAbsence(userId, data) {
    return this.post(`users/${userId}/absenceSchedule`, data);
  }
  updateUserAbsence(userId, absenceId, data) {
    return this.put(`users/${userId}/absenceSchedule/${absenceId}`, data);
  }
  deleteUserAbsence(userId, absenceId) {
    return this.delete(`users/${userId}/absenceSchedule/${absenceId}`);
  }
  // DEVICE
  getDevices() {
    return this.get('client/devices');
  }
  addDevices(device) {
    return this.post('client/devices', device);
  }
  addPNSHandle(device) {
    return this.patch('client/devices/pnsHandle', device);
  }
  deactivateDevice(deviceId) {
    return this.patch(`client/devices/deactivate/${deviceId}`, null);
  }
  updateDevice(DeviceUpdateRequest) {
    return this.patch('client/devices', DeviceUpdateRequest);
  }
  deleteDevice(deviceId) {
    return this.delete(`client/devices/${deviceId}`);
  }
  // APP-PERMISSIONS
  getAppPermissions(deviceId) {
    return this.get(`client/devices/permissions/${deviceId}`);
  }
  addAppPermissions(PermissionsModel) {
    return this.post('client/devices/permissions', PermissionsModel);
  }
  updateAppPermissions(PermissionsModel) {
    return this.patch('client/devices/permissions', PermissionsModel);
  }
  revokeAppPermissions(PermissionsModel) {
    return this.delete('client/devices/permissions', undefined, this.options, PermissionsModel);
  }
  // USER GROUPS
  saveUserToGroup(userId, userGroupId) {
    return this.post(`user/${userId}/usergroup/${userGroupId}`, null);
  }
  batchSaveUsersToGroup(assignUserGroups) {
    return this.post('users/usergroups', assignUserGroups);
  }
  batchDeleteUsersFromGroup(users) {
    return this.delete('users/usergroups', undefined, this.options, users);
  }
  deleteUserFromGroup(userId, userGroupId) {
    return this.delete(`user/${userId}/usergroup/${userGroupId}`);
  }
  createUserGroup(userGroup) {
    return this.post('usergroup', userGroup);
  }
  updateUserGroup(userGroup, userGroupId) {
    return this.put(`usergroup/${userGroupId}`, userGroup);
  }
  getUserGroups(userId) {
    return this.get(`user/${userId}/usergroups`);
  }
  deleteUserGroup(groupId) {
    return this.delete(`usergroup/${groupId}`);
  }
  refreshToken(userToken) {
    return this.post('authentication/refresh', userToken);
  }
  createClient(data) {
    return this.post('client', data);
  }
  createTempUser() {
    return this.post('client/true', null);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  confirmEmail() {
    return this.post('email/confirmEmail', null, this.optionsWithEmailToken);
  }
  login(data) {
    return this.post('authentication/login', data);
  }
  forcedPasswordReset(data) {
    return this.put('password/forcedPasswordReset', data);
  }
  logout() {
    return this.post('authentication/logout', null);
  }
  requestResetPassword(data) {
    return this.post('password/requestPasswordReset', data);
  }
  resetPassword(data) {
    return this.put('password/resetPassword', data);
  }
}
exports.CordIamService = CordIamService;
CordIamService.instance = null;
